import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { useParams } from "react-router";
import "./business.scss";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import Sidebar from "../Sidebar/index";
import { useNavigate } from "react-router";
import {
  createBusninessContactAction,
  uploadBusninessContactFileAction,
  deleteStorePhotoAction,
  adressTokenAction,
  searchdetailAction,
  addressdetailAction,
  tvsLatLongAuthTokenAPI
} from "../../actions/profileAction";
import { getDistributorsListAction } from "../../actions/distributorsAction"
import { getverificationDocumentAction } from "../../actions/verificationDocumentAction";
import { useDispatch } from "react-redux";
import { safeEncode } from "../../common/encoder";
import { safeDecode } from "../../common/decoder";
import Validation from "../../constants/validation/Validation";
import { NotificationManager } from "react-notifications";
import Loader from "../../component/loaderComponent/Loader";
import Cookies from "js-cookie";
import { Box, Text } from "rebass";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import { pgmFilterButtonAction } from "../../actions/pgmAction";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import { fileType } from "../../constants/filetype/filetype";
import { COUNTRY_VALIDATION_FIELDS } from "../../constants/validation/CountryValidation";
import { CITY_STATE_VALIDATION_FIELDS } from "../../constants/validation/CountryValidation";

const BusinessPartners = () => {
  const [activeButton, setActiveButton] = useState(3);
  const navigate = useNavigate();
  const { id } = useParams();
  const decodeid = safeDecode(id);
  const [show, setshow] = useState(false);
  const [showcommercial, setshowCommercial] = useState(false);
  const [showpersonal, setshowPersoonal] = useState(false);
  const [sameadress, setsameaddress] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const [personnal, setPersonal] = useState(false);
  const [imgLoading, setImgloading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [collapsepersonal, setCollapsePersonal] = useState(false);
  const [collapsecommercial, setCollapsecommercial] = useState(false);
  const [commercialref, setcommercialref] = useState("");
  const [personalref, setpersonalref] = useState("");
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");
  const languageCode = Cookies.get("languageCode");
  const countryDomain = localStorage.getItem('countryCode');
  const kenyaValidation = COUNTRY_VALIDATION_FIELDS.includes(countryDomain);
  const CityStateValidation = CITY_STATE_VALIDATION_FIELDS.includes(countryDomain);

  const handelCollpasespersonal = (param) => {
    setCollapsePersonal(!collapsepersonal);
    setcommercialref("Commercial References");
  };

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  const handelCollpasescommercial = (param) => {
    setCollapsecommercial(!collapsecommercial);
    setpersonalref("Personal References");
  };
  const [getDistributorsList, setGetDistributorsList] = useState([])
  async function DistributorsListData() {
    let response = await dispatch(getDistributorsListAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setGetDistributorsList(response.data.data.results);
    }
  }
  const Country_name = safeDecode(Cookies.get('country_name'));
  // Todo later as per reqirement
  // const [getVerificationList, setGetVerificationList] = useState([])
  // async function VerificationListData() {
  //   let response = await dispatch(getverificationDocumentAction());
  //   if (response.status === HTTP_STATUS.SUCCESS) {
  //     setGetVerificationList(response.data.data);
  //   }
  // }

  const [selectedVehicle, setSelectedVehicle] = useState("2W");
  const [isChecked, setIsChecked] = useState(true);
  const [uploadIdfile, setuploadIdfile] = useState(null);
  const [constitutiveact, setConstitutiveact] = useState(null);
  const [rec, setrfc] = useState(null);
  const [addressProof, setaddressProof] = useState(null);
  const [bankAccount, setbankAccount] = useState(null);
  const [otherfile, setOtherfile] = useState(null);

  const filerec = useRef(null);
  const fileaddressProof = useRef(null);
  const filebankAccount = useRef(null);
  const fileotherfile = useRef(null);
  const fileUpload_id = useRef(null);
  const fileConstitutive_act = useRef(null);
  const store_image = useRef(null);

  const [states, setDataStates] = useState({
    role: "",
    distributor: "",
    year_of_experience: 1,
    type_of_vehicle: selectedVehicle,
    name_of_business: "",
    name_as_per_business_record: "",
    gps_address: "",
    postal_code: "",
    city: "",
    state: "",
    province: "",
    detailed_address: "",
    previously_trained_by_tvs: true,
    privacy_policy_accepted: isChecked,
    received_training_by_tvs: "",
    term_and_condition: true,
    // verification_id: "",    // Todo later as per reqirement
    verification_id_number: "",
    business_reference: [
      {
        reference_type: "",
        name: "",
        Address: "",
        postal_code: "",
        city_state_name: "",
        phone: "",
      },
    ],
    business_references_addmore: [
      {
        reference_type: "",
        name: "",
        Address: "",
        postal_code: "",
        city_state_name: "",
        phone: "",
      },
    ],
    personal_reference: [
      {
        reference_type: "",
        name: "",
        Address: "",
        postal_code: "",
        city_state_name: "",
        phone: "",
      },
    ],
    personal_reference_addmore: [
      {
        reference_type: "",
        name: "",
        Address: "",
        postal_code: "",
        city_state_name: "",
        phone: "",
      },
    ],
    delivery_address: [
      {
        gps_address: "",
        postal_code: "",
        city: "",
        province: "",
        detailed_address: "",
      },
    ],
  });

  const [access_token, setaccess_token] = useState("");
  const [suggested_address, setsuggested_address] = useState([]);
  const [suggested_delivery_address, setsuggested_delivery_address] = useState([]);
  const [suggested_commercial_address, setsuggested_commercial_address] = useState([]);
  const [suggested_commercial_add_more_address, setsuggested_commercial_add_more_address] = useState([]);
  const [suggested_personal_address, setsuggested_personal_address] = useState([]);
  const [suggested_personal_add_more_address, setsuggested_personal_add_more_address] = useState([]);
  const [name_of_business_character_count, setName_of_Business_Character_Count] = useState(0);
  const [complete_address_character_count, setComplete_Address_Character_Count] = useState(0);
  const [delivery_address_character_count, setDelivery_Address_Character_Count] = useState(0);
  const [showPincodeList, setShowPincodeList] = useState({
    searchText: false,
  });
  const [deliveryLocationList, setDeliveryLocationList] = useState({
    searchText: false,
  });
  const [commercialLocationList, setcommercialLocationList] = useState({
    searchText: false,
  });
  const [commercialAddMoreLocationList, setcommercialAddMoreLocationList] = useState({
    searchText: false,
  });
  const [personalLocationList, setpersonalLocationList] = useState({
    searchText: false,
  });
  const [personalAddMoreLocationList, setpersonalAddMoreLocationList] = useState({
    searchText: false,
  });

  const dispatch = useDispatch();
  useEffect(() => {
    handleChangeLanguage(language);
    GetLatLongAuthToken();
    DistributorsListData();
    // VerificationListData();  // Todo later as per reqirement
  }, []);

  function updateBusinessNameCharsters(e) {
    const text = document.getElementById("name_as_per_business_record")?.value;
    setName_of_Business_Character_Count(text?.length);
  }
  function updateCompleteAddressCharsters(e) {
    const text = document?.getElementById("detailed_address")?.value;
    setComplete_Address_Character_Count(text?.length);
  }
  function updateDeliveryAddressCharsters(e) {
    const text = document.getElementById("detailed_delivery_address")?.value;
    setDelivery_Address_Character_Count(text?.length);
  }
  const handleChange = (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
    updateBusinessNameCharsters();
    updateCompleteAddressCharsters();
  };

  const handleRadioChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setDataStates({ ...states, [name]: value });
  };

  const handleCommercialChange = (evt) => {
    const { name, value } = evt.target;
    setDataStates({
      ...states,
      business_reference: [
        {
          ...states.business_reference?.[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
  };
  const handlepersonalrefChange = (evt) => {
    const { name, value } = evt.target;

    setDataStates({
      ...states,
      personal_reference: [
        {
          ...states?.personal_reference?.[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
  };
  const handlepersonalrefChangeAddmore = (evt) => {
    const { name, value } = evt.target;

    setDataStates({
      ...states,
      personal_reference_addmore: [
        {
          ...states.personal_reference_addmore[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
  };
  const handleCommercialChangeAddmore = (evt) => {
    const { name, value } = evt.target;
    setDataStates({
      ...states,
      business_references_addmore: [
        {
          ...states?.business_references_addmore[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
  };

  const handledeliveryaddChange = (evt) => {
    const { name, value } = evt.target;

    setDataStates({
      ...states,
      delivery_address: [
        {
          ...states?.delivery_address?.[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
    updateDeliveryAddressCharsters();
  };

  const imagefile = fileType.IMAGE;
  const handleFileUpload = async (event, setFile, notificationLabel, fileType=imagefile) => {
    const file = event.target.files[0];

    if (file) {
      if (fileType.includes(file.type)) {
        setFile(file);

        const reqdata = {
          user_id: decodeid,
          [notificationLabel]: event.target.files[0],
        };

        try {
          let response = await dispatch(uploadBusninessContactFileAction(reqdata));
          if (response.status === HTTP_STATUS.SUCCESS) {
            NotificationManager.success(response.data.message);
          }
        } catch (error) {
          NotificationManager.error("Error uploading image:", error);
        }
      } else {
        NotificationManager.error(t('validationmsg.invalidimage'));
        event.target.value = null;
      }
    }
  };

  const handleFileVerificationUploads = (event) => {
    handleFileUpload(event, setuploadIdfile, 'upload_verification_id');
  };

  const handleFilerec = (event) => {
    handleFileUpload(event, setrfc, 'rfc');
  };

  const handleFileaddressProof = (event) => {
    handleFileUpload(event, setaddressProof, 'address_proof');
  };

  const handleFilebankAccount = (event) => {
    handleFileUpload(event, setbankAccount, 'bank_account_receipt');
  };

  const handleFileotherfile = (event) => {
    handleFileUpload(event, setOtherfile, 'others');
  };

  const handleFileConstitutiveact = (event) => {
    handleFileUpload(event, setConstitutiveact, 'constitutive_act');
  };

  const handleVehicleClick = (vehicleType) => {
    setSelectedVehicle(vehicleType);
  };

  const [selectedImages, setSelectedImages] = useState([]);

  const handleImageChange = async (event) => {
    const files = event.target.files;
    const newImagesData = [];
    const maxUploads = 4; // Maximum number of uploads allowed
    if (selectedImages.length >= maxUploads) {
      NotificationManager.error(t('validationmsg.maxfileupload'));
      return;
    }
    const allowedImageTypes = fileType.IMAGE;
    for (let i = 0; i < files.length; i++) {
      if (selectedImages.length + newImagesData.length >= maxUploads) {
        NotificationManager.error(t('validationmsg.maxfileupload'));
        break;
      }
      const file = files[i];
      if (allowedImageTypes.includes(file.type)) {
        const formData = new FormData();
        formData.append("user_id", decodeid);
        formData.append("store_photo", file ? file : null);
        setImgloading(true);

        try {
          const response = await dispatch(uploadBusninessContactFileAction(formData));
          if (response.status === HTTP_STATUS.SUCCESS) {
            NotificationManager.success(response.data.message);
            const imageId = response?.data?.data?.store_photo_id;
            const imageData = {
              id: imageId,
              file: file,
            };

            newImagesData?.push(imageData ? imageData : "");
            if (newImagesData?.length === files?.length) {
              setSelectedImages([...selectedImages, ...newImagesData]);
            }
            setImgloading(false);
          } else if (response === undefined) {
            setImgloading(false);
          } else {
            NotificationManager.error("Error uploading image:", response);
          }
        } catch (error) {
          NotificationManager.error("Error uploading image:", error);
        }
      } else {
        NotificationManager.error(t('validationmsg.invalidimage'));
        event.target.value = null;
      }
    }
  };

  const handleCheckboxClick = () => {
    setsameaddress(!sameadress);
  };

  const deleteStorephoto = async (id) => {
    setImgloading(true);
    let response = await dispatch(deleteStorePhotoAction(id));
    if (response.status === HTTP_STATUS.SUCCESS) {
      NotificationManager.success(response.data.message);
      setImgloading(false);
      window.scroll(0, 0);
      const updatedImages = selectedImages.filter((image) => image.id !== id);
      setSelectedImages(updatedImages);
    } else if (response === undefined) {
      setImgloading(false);
    }
  };
  const GetLatLongAuthToken = () => {
    const EnableTvsLatLong = process.env.REACT_APP_ENABLE_TVS_LAT_LONG_API
    if (EnableTvsLatLong) {
      tvsLatlongAuthTokenApi();
    } else {
      latlongAuthTokenApi();
    }
  }

  const latlongAuthTokenApi = async () => {
    setIsLoading(true)
    let response = await dispatch(adressTokenAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      Cookies.set("access_token", safeEncode(response.data.data.access_token), {
        expires: 1,
      });
      setaccess_token(response.data.data.access_token);
      setIsLoading(false);
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };

  const tvsLatlongAuthTokenApi = async () => {
    setIsLoading(true);
    let response = await dispatch(tvsLatLongAuthTokenAPI());
    if (response.status === HTTP_STATUS.SUCCESS) {
      Cookies.set("access_token", safeEncode(response.data.access_token), {
        expires: 1,
      });
      setaccess_token(response.data.access_token);
      setIsLoading(false);
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };

  const togglePincodeList = (field, show) => {
    setShowPincodeList((prevState) => ({
      ...prevState,
      [field]: show,
    }));
  };

  const deliveryPincodeList = (field, show) => {
    setDeliveryLocationList((prevState) => ({
      ...prevState,
      [field]: show,
    }));
  };

  const commercailPincodeList = (field, show) => {
    setcommercialLocationList((prevState) => ({
      ...prevState,
      [field]: show,
    }));
  };
  const commercailAddMorePincodeList = (field, show) => {
    setcommercialAddMoreLocationList((prevState) => ({
      ...prevState,
      [field]: show,
    }));
  };
  const personalPincodeList = (field, show) => {
    setpersonalLocationList((prevState) => ({
      ...prevState,
      [field]: show,
    }))
  };
  const personalAddMorePincodeList = (field, show) => {
    setpersonalAddMoreLocationList((prevState) => ({
      ...prevState,
      [field]: show,
    }))
  };
  const addressDetails = async (latitude, longitude, data) => {
    togglePincodeList("searchText", false);
    setDataStates({
      ...states,
      gps_address: data.replace(/^ +/gm, ""),
    });
    let response = await dispatch(
      addressdetailAction(latitude, longitude, access_token, Country_name)
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setImgloading(false);
      window.scroll(0, 0);

      setDataStates({
        ...states,
        gps_address: data.replace(/^ +/gm, ""),
        city: response.data.city === null ? "" : response.data.city,
        province: response.data.state === null ? "" : response.data.state,
        postal_code: response.data.pincode === null ? "" : response.data.pincode
      });
    } else if (response === undefined) {
      setImgloading(false);
    }
  };

  const deliveryaddressDetails = async (latitude, longitude, data) => {
    deliveryPincodeList("searchText", false);
    setDataStates({
      ...states,
      delivery_address: [
        {
          ...states?.delivery_address?.[0],
          gps_address: data.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(
      addressdetailAction(latitude, longitude, access_token, Country_name)
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setImgloading(false);
      window.scroll(0, 0);
      setDataStates({
        ...states,
        delivery_address: [
          {
            ...states?.delivery_address?.[0],
            gps_address: data.replace(/^ +/gm, ""),
            city: response.data.city === null ? "" : response.data.city,
            province: response.data.state === null ? "" : response.data.state,
            postal_code: response.data.pincode === null ? "" : response.data.pincode
          },
        ],
      });
    } else if (response === undefined) {
      setImgloading(false);
    }
  };
  const commercialAddressDetails = async (latitude, longitude, data) => {
    commercailPincodeList("searchText", false);
    setDataStates({
      ...states,
      business_reference: [
        {
          ...states?.business_reference?.[0],
          Address: data.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(
      addressdetailAction(latitude, longitude, access_token, Country_name)
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setImgloading(false);
      window.scroll(0, 0);
      setDataStates({
        ...states,
        business_reference: [
          {
            ...states?.business_reference?.[0],
            Address: data.replace(/^ +/gm, ""),
            postal_code: response.data.pincode === null ? "" : response.data.pincode,
            city_state_name: `${response.data.city === null ? "" : response.data.city}, ${response.data.state === null ? "" : response.data.state}`,
          },
        ],
      });
    } else if (response === undefined) {
      setImgloading(false);
    }
  };
  const commercialAddMoreAddressDetails = async (latitude, longitude, data) => {
    commercailAddMorePincodeList("searchText", false);
    setDataStates({
      ...states,
      business_references_addmore: [
        {
          ...states?.business_references_addmore?.[0],
          Address: data.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(
      addressdetailAction(latitude, longitude, access_token, Country_name)
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setImgloading(false);
      window.scroll(0, 0);
      setDataStates({
        ...states,
        business_references_addmore: [
          {
            ...states?.business_references_addmore?.[0],
            Address: data.replace(/^ +/gm, ""),
            postal_code: response.data.pincode === null ? "" : response.data.pincode,
            city_state_name: `${response.data.city === null ? "" : response.data.city}, ${response.data.state === null ? "" : response.data.state}`,
          },
        ],
      });
    } else if (response === undefined) {
      setImgloading(false);
    }
  };
  const personalAddressDetails = async (latitude, longitude, data) => {
    personalPincodeList("searchText", false);
    setDataStates({
      ...states,
      personal_reference: [
        {
          ...states.personal_reference[0],
          Address: data.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(
      addressdetailAction(latitude, longitude, access_token, Country_name)
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setImgloading(false);
      window.scroll(0, 0);
      setDataStates({
        ...states,
        personal_reference: [
          {
            ...states.personal_reference[0],
            Address: data.replace(/^ +/gm, ""),
            postal_code: response.data.pincode === null ? "" : response.data.pincode,
            city_state_name: `${response.data.city === null ? "" : response.data.city}, ${response.data.state === null ? "" : response.data.state}`,
          },
        ],
      });
    } else if (response === undefined) {
      setImgloading(false);
    }
  };
  const personalAddMoreAddressDetails = async (latitude, longitude, data) => {
    personalAddMorePincodeList("searchText", false);
    setDataStates({
      ...states,
      personal_reference_addmore: [
        {
          ...states.personal_reference_addmore[0],
          Address: data.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(
      addressdetailAction(latitude, longitude, access_token, Country_name)
    );
    if (response.status === HTTP_STATUS.SUCCESS) {
      setImgloading(false);
      window.scroll(0, 0);
      setDataStates({
        ...states,
        personal_reference_addmore: [
          {
            ...states.personal_reference[0],
            Address: data.replace(/^ +/gm, ""),
            postal_code: response.data.pincode === null ? "" : response.data.pincode,
            city_state_name: `${response.data.city === null ? "" : response.data.city}, ${response.data.state === null ? "" : response.data.state}`,
          },
        ],
      });
    } else if (response === undefined) {
      setImgloading(false);
    }
  };
  const handleAddress = async (evt) => {
    const value = evt.target.value;
    setIsLoading(true)
    setDataStates({
      ...states,
      [evt.target.name]: value.replace(/^ +/gm, ""),
    });
    let response = await dispatch(searchdetailAction(access_token, value,Country_name));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setsuggested_address(response.data.data);
      setIsLoading(false)
    }
  };

  const handledeliveryAddress = async (evt) => {
    const value = evt.target.value;
    setDataStates({
      ...states,
      delivery_address: [
        {
          ...states?.delivery_address?.[0],
          [evt.target.name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(searchdetailAction(access_token, value, Country_name));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setsuggested_delivery_address(response?.data?.data);
    }
  };

  const handleCommercialAddress = async (evt) => {
    const { name, value } = evt.target;
    setDataStates({
      ...states,
      business_reference: [
        {
          ...states?.business_reference?.[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(searchdetailAction(access_token, value, Country_name));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setsuggested_commercial_address(response.data.data);
    }
  };
  const handleCommercialAddMoreAddress = async (evt) => {
    const { name, value } = evt.target;
    setDataStates({
      ...states,
      business_references_addmore: [
        {
          ...states?.business_references_addmore?.[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(searchdetailAction(access_token, value, Country_name));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setsuggested_commercial_add_more_address(response.data.data);
    }
  };
  const handlepersonalAddress = async (evt) => {
    const { name, value } = evt.target;
    setDataStates({
      ...states,
      personal_reference: [
        {
          ...states.personal_reference[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(searchdetailAction(access_token, value, Country_name));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setsuggested_personal_address(response.data.data);
    }
  };
  const handlepersonalAddMoreAddress = async (evt) => {
    const { name, value } = evt.target;
    setDataStates({
      ...states,
      personal_reference_addmore: [
        {
          ...states.personal_reference_addmore[0],
          [name]: value.replace(/^ +/gm, ""),
        },
      ],
    });
    let response = await dispatch(searchdetailAction(access_token, value, Country_name));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setsuggested_personal_add_more_address(response.data.data);
    }
  };
  const addBusinesspartner = async () => {
    const businessReferenceArray = [];

    const requestData = {
      user_id: decodeid,
      distributor: states.role,
      year_of_experience: states.year_of_experience,
      type_of_vehicle: selectedVehicle,
      name_of_business: states.name_of_business,
      name_as_per_business_record: states.name_as_per_business_record,
      gps_address: states.gps_address,
      postal_code: states.postal_code,
      ...(CityStateValidation ? {
        ...(states.city ? { city: states.city } : ""),
        ...(states.province ? { province: states.province } : "")
      } : {
        city: states.city,
        province: states.province
      }),
      detailed_address: states?.detailed_address,
      business_privacy_policy_accepted: states.business_privacy_policy_accepted,
      term_and_condition: true,
      previously_trained_by_tvs: states.received_training_by_tvs,
      // verification_id: states.verification_id,    // Todo later as per reqirement
      delivery_address: sameadress
        ? [
          {
            gps_address: states?.gps_address,
            postal_code: states?.postal_code,
            ...(CityStateValidation ? {
              ...(states?.city ? { city: states?.city } : ""),
              ...(states?.province ? { province: states?.province } : "")
            } : {
              city: states?.city,
              province: states?.province
            }),
            deatiled_address: states?.detailed_address,
          },
        ]
        : [
          {
            gps_address: states?.delivery_address?.[0]?.gps_address,
            postal_code: states?.delivery_address?.[0]?.postal_code,
            ...(CityStateValidation ? {
              ...(states?.delivery_address?.[0]?.city ? { city: states?.delivery_address?.[0]?.city } : ""),
              ...(states?.delivery_address?.[0]?.province ? { province: states?.delivery_address?.[0]?.province } : "")
            } : {
              city: states?.delivery_address?.[0].city,
              province: states?.delivery_address?.[0].province
            }),
            deatiled_address: states?.delivery_address?.[0]?.detailed_address,
          },
        ],

      business_reference: businessReferenceArray,
    };
    setIsLoading(true);

    let response = await dispatch(createBusninessContactAction(requestData));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      NotificationManager.success(response?.data?.message);
      dispatch(pgmFilterButtonAction("pending"));
      setIsLoading(false);
      navigate(`/pgmlist`);
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
      window.scroll(0, 0);
    }
  };
  function RedirectPrivacyPolicy() {
    if(languageCode === "en"){
      window.open(`/kdm_privacy_policy`, "_blank");
    }
    else if(languageCode === "mx"){
      window.open(`/mx/kdm_privacy_policy`, "_blank");
    }
  }
  const [selectedOption, setSelectedOption] = useState("Yes");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const ButtonsActive = (buttonData) => {
    setActiveButton(buttonData);
  };

  return (
    <div className="details_containers_pgmbusiness">
      <div className="businessContainer">
        <div className="businessContainers">
          <div className="businessConntainersright">
            <div className="header_border">
              <p className="pgm-list-header-text">TVS &gt; {t('questionnaire.addeditpgm')}</p>
            </div>
            <div className="pgmlist_buttons_containers">
              <div className="pgmlist_buttons">
                <button
                  className={
                    activeButton === "Pending"
                      ? "activeAddnew"
                      : "pgmlist_Approved"
                  }
                  onClick={() => ButtonsActive("Pending")}
                >
                  {t('pgmlist.buttons.pending')}
                </button>
                <button
                  className={
                    activeButton === "Approved"
                      ? "activeAddnew"
                      : "pgmlist_Approved"
                  }
                  onClick={() => ButtonsActive("Approved")}
                >
                  {t('pgmlist.buttons.approved')}
                </button>
                <button
                  className={
                    activeButton === "/pgmlist"
                      ? "activeAddnew"
                      : "pgmlist_Approved"
                  }
                  onClick={() => ButtonsActive("Draft")}
                >
                  {t('pgmlist.buttons.draft')}
                </button>
                <button
                  className={
                    activeButton === "Add new partners"
                      ? "activeAddnew"
                      : "pgmlist_Approved"
                  }
                  onClick={() => ButtonsActive("Add new partners")}
                >
                  {t('pgmlist.buttons.addNewPartner')}
                </button>
              </div>
            </div>
            <div className="Partner_para_four">
              <div className="Partner_para_fours">
                <div className="Partner_para_fours_child">
                  <span className="Partner_para_four_spans">1</span>
                  <p className="Partner_para_four_paragraphs">{t('addpartner.profile')}</p>
                </div>
                <div className="Partner_para_fours_child">
                  <span className="Partner_para_four_span">2</span>
                  <p className="Partner_para_four_paragraph">
                    {t('addpartner.businessContactReferences')}
                  </p>
                </div>
              </div>
            </div>
            <div className="Busiinesspara_first">
              {t('businessdetail.typeOfVehicleDealingWith')}
            </div>
            <div className="Businesspara_seconds">
              <button
                className={
                  selectedVehicle === "2W"
                    ? "selected"
                    : "Businesspara_seconds_first"
                }
                onClick={() => handleVehicleClick("2W")}
              >
                {t('businessdetail.twoWheeler')}
              </button>
              <button
                className={
                  selectedVehicle === "3W"
                    ? "selected"
                    : "Businesspara_seconds_first"
                }
                onClick={() => handleVehicleClick("3W")}
              >
                {t('businessdetail.threeWheeler')}
              </button>
              <button
                className={
                  selectedVehicle === "2W AND 3W"
                    ? "selected"
                    : "Businesspara_seconds_first"
                }
                onClick={() => handleVehicleClick("2W AND 3W")}
              >
                {t('businessdetail.both')}
              </button>
            </div>
            <div>
              <div className="loginthirdpara">
                <div class="input-wrapper input-wrappers">
                  <label for="first">
                    {t('businessdetail.selectDistributor')} <span style={{ color: "red" }}>*</span>
                  </label>
                  <select
                    id="role"
                    name="role"
                    value={states.role}
                    onChange={handleChange}
                  >
                    <option value="">{t('businessdetail.selectDistributor')}</option>
                    {getDistributorsList.length > 0 && (<>
                      {getDistributorsList?.map((data) => (
                        <option key={data.id} value={data.name}>
                          {data.name}
                        </option>
                      ))}
                    </>)}
                  </select>
                </div>
              </div>
            </div>
            <div>
              <div className="loginthirdpara">
                <div class="input-wrapper inputwrappers">
                  <label for="search">
                    {t('businessdetail.businessName')}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t('businessdetail.enterBusinessName')}
                    name="name_of_business"
                    rows={10}
                    cols={50}
                    value={states.name_of_business}
                    onChange={handleChange}
                    id="name_of_business"
                    maxLength={25}
                    minLength={3}
                  />
                  {
                    states.name_of_business.length > 0 && ((states.name_of_business.length < 6) ||
                      (states.name_of_business.length > 25))
                      ? <div id="message">
                        {t('businessdetail.enterBusinessNameError')}
                      </div>
                      : ""}
                </div>
                <div class="input-wrapper inputsbusinessrecords">
                  <label for="search">
                    {t('businessdetail.nameAsPerBusinessRecord')}
                    <span style={{ color: "red" }}>*</span>
                    <p className='text-count-name-of-business-record'>{name_of_business_character_count}/25</p>
                  </label>
                  <input
                    type="text"
                    value={states.name_as_per_business_record}
                    placeholder={t('businessdetail.nameAsPerBusinessRecordplaceholder')}
                    name="name_as_per_business_record"
                    onChange={handleChange}
                    maxLength={25}
                    minLength={3}
                    id="name_as_per_business_record"
                  />
                  {
                    states.name_as_per_business_record.length > 0 && ((states.name_as_per_business_record.length < 3) ||
                      (states.name_as_per_business_record.length > 25))
                      ? <div id="message">
                        {t('businessdetail.nameAsPerBusinessRecordError')}
                      </div>
                      : ""}
                </div>
              </div>
            </div>

            <div>
              <div className="loginthirdpara">
                <div class="input-wrapper inputsbusinessrecords">
                  <label for="search">
                    {!kenyaValidation ? t('common.location/pincode') : t('common.location')}<span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={!kenyaValidation ? t('common.locationPlaceholder') : t('common.enterLocation')}
                    name="gps_address"
                    value={states.gps_address}
                    onChange={handleAddress}
                    onFocus={() => togglePincodeList("searchText", true)}
                  />
                  <div className="loader-location">
                    {isLoading ? (<Loader />) : ''}
                  </div>
                  {showPincodeList.searchText && (
                    <div className="">
                      <span className="sendinvitelabel"></span>
                      {suggested_address?.length > 0 ? (
                        <Box className="suggestion-address cursor-pointer">
                          {suggested_address?.length > 0 &&
                            suggested_address?.map((item, i) => (
                              <Text
                                key={i}
                                className="search-childText cursor-pointer"
                                onClick={() =>
                                  addressDetails(
                                    item.coordinates.latitude,
                                    item.coordinates.longitude,
                                    item.name
                                  )
                                }
                              >
                                {item.name}
                              </Text>
                            ))}
                        </Box>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                </div>

                <div class="input-wrapper inputsbusinessrecords">
                  <label for="search">
                    {t('common.city')} 
                    { !CityStateValidation && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <input
                    type="text"
                    placeholder={t('common.cityPlaceholder')}
                    name="city"
                    value={states.city}
                    onChange={handleChange}
                    readOnly
                  />
                </div>
                <div class="input-wrapper inputsbusinessrecords">
                  <label for="search">
                    {!kenyaValidation ? t('common.provinceState') : t('common.provinceStateCounty')} 
                    { !CityStateValidation && <span style={{ color: "red" }}>*</span>}
                  </label>
                  <input
                    type="text"
                    placeholder={!kenyaValidation ? t('common.provinceStatePlaceholder') : t('common.provinceStateCountyPlaceholder')}
                    name="province"
                    value={states.province}
                    onChange={handleChange}
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="loginthirdpara">
                <div class="input-wrapper inputsbusinessrecords">
                  <label for="search">
                    {t('common.completeAddress')} <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    placeholder={t('common.completeAddressPlaceholder')}
                    name="detailed_address"
                    id="detailed_address"
                    rows={10}
                    cols={50}
                    maxLength={50}
                    value={states?.detailed_address}
                    onChange={handleChange}
                  />
                  <p className='text_count_complete_address text_count'>{complete_address_character_count}/50</p>
                </div>
              </div>
            </div>
            <div className="tvs-training-ques">
              <div>
                <span className="workshoptext">
                  {t('businessdetail.trainingByTVS')}
                  <span style={{ color: "red" }}>*</span>
                </span>
              </div>
              <div className="Seven_para">
                <input
                  type="radio"
                  name="received_training_by_tvs"
                  value="Yes"
                  checked={states.received_training_by_tvs === "Yes"}
                  onChange={handleRadioChange}
                />
                <span>{t('common.yes')}</span>
                <input
                  type="radio"
                  name="received_training_by_tvs"
                  value="No"
                  checked={states.received_training_by_tvs === "No"}
                  onChange={handleRadioChange}
                />
                <span className="Seven_para_span">{t('common.no')}</span>
              </div>
            </div>
            <div className="business_paraseven">
              <input
                type="checkbox"
                className="input_checkbox"
                onClick={handleCheckboxClick}
                checked={sameadress}
              />
              <span>
                {t('businessdetail.useSameAddress')}
                <span style={{ color: "red" }}>*</span>
              </span>
            </div>
            {!sameadress && (
              <div class="input-wrapper inputsbusinessrecords">
                <input
                  type="text"
                  placeholder={t('businessdetail.addDeliveryAddress')}
                  name="userid"
                  className="dash"
                  readOnly
                  onClick={(e) => setshow(!show)}
                />
              </div>
            )}
            {!sameadress && (
              <>
                {show && (
                  <>
                    <div>
                      <div className="loginthirdpara">
                        <div class="input-wrapper inputsbusinessrecords">
                          <label for="search">
                            {t('common.location/pincode')}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t('common.locationPlaceholder')}
                            name="gps_address"
                            value={states?.delivery_address?.[0].gps_address}
                            onChange={handledeliveryAddress}
                            onFocus={() =>
                              deliveryPincodeList("searchText", true)
                            }
                          />
                          {deliveryLocationList.searchText && (
                            <div className="">
                              <span className="sendinvitelabel"></span>
                              {suggested_delivery_address?.length > 0 ? (
                                <Box className="suggestion-address">
                                  {suggested_delivery_address?.length > 0 &&
                                    suggested_delivery_address?.map(
                                      (item, i) => (
                                        <Text
                                          key={i}
                                          className="search-childText"
                                          onClick={() =>
                                            deliveryaddressDetails(
                                              item.coordinates.latitude,
                                              item.coordinates.longitude,
                                              item.name
                                            )
                                          }
                                        >
                                          {item.name}
                                        </Text>
                                      )
                                    )}
                                </Box>
                              ) : (
                                ""
                              )}
                            </div>
                          )}
                        </div>
                        <div class="input-wrapper inputsbusinessrecords">
                          <label for="search">
                            {t('common.city')}
                            {!CityStateValidation && <span style={{ color: "red" }}>*</span>}
                          </label>
                          <input
                            type="text"
                            placeholder={t('common.cityPlaceholder')}
                            name="city"
                            value={states?.delivery_address?.[0].city}
                            onChange={handledeliveryaddChange}
                            readOnly
                          />
                        </div>
                        <div class="input-wrapper inputsbusinessrecords">
                          <label for="search">
                            {t('common.provinceState')}
                            {!CityStateValidation && <span style={{ color: "red" }}>*</span>}
                          </label>
                          <input
                            type="text"
                            placeholder={t('common.provinceStatePlaceholder')}
                            name="province"
                            value={states?.delivery_address?.[0].province}
                            onChange={handledeliveryaddChange}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="loginthirdpara">
                        <div class="input-wrapper inputsbusinessrecords">
                          <label for="search">
                            {t('common.completeAddress')}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            placeholder={t('common.completeAddressPlaceholder')}
                            name="detailed_address"
                            id="detailed_delivery_address"
                            rows={10}
                            cols={50}
                            maxLength={50}
                            value={states?.delivery_address?.[0]?.detailed_address}
                            onChange={handledeliveryaddChange}
                          />
                          <p className='text_count_complete_address text_count'>{delivery_address_character_count}/50</p>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
            <div className="veryficationdoc">
              <div class="verification-container">
                <div class="verification-line"></div>
                <div class="verification-text">{t('businessdetail.verificationDocuments')}</div>
                <div class="verification-line"></div>
              </div>
            </div>
            <div>
              <div>
                <div className="busiess-partners-veryfications-documents">
                  <div class="input-wrapper inputsbusinessrecords">
                    <label for="search" htmlFor="other">
                      {Country_name.toLowerCase() === "mexico" ? t('businessdetail.govermentId') : t('businessdocuments.document1')}
                    </label>
                    <input
                      className="business-contact-pages-input cursor-pointer"
                      id="Upload_id"
                      onChange={handleFileVerificationUploads}
                      hidden
                      type="file"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.nationalidproof') : t('common.+upload')}
                      name="userid"
                      accept="image/png,image/jpg, image/jpeg,.pdf"
                      ref={fileUpload_id}
                    />
                    <input
                      type="text"
                      id="Upload_id"
                      readOnly
                      className="selectfile-file cursor-pointer"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.nationalidproof') : t('common.+upload')}
                      value={uploadIdfile?.name}
                      onClick={() => fileUpload_id.current.click()}
                    />
                    {Country_name.toLowerCase() === "mexico" ?
                      <span class="business-partners-span-text cursor-pointer" onClick={() => fileUpload_id.current.click()}>
                        {Country_name.toLowerCase() === "mexico" ? t('common.+upload') : t('businessdocuments.document1')}
                      </span>
                      : ""}
                    <label
                      className="select-vehicle-input cursor-pointer"
                      htmlFor="Upload_id"
                    ></label>
                  </div>
                  <div class="input-wrapper inputsbusinessrecords">
                    <label for="search" htmlFor="other">
                      {Country_name.toLowerCase() === "mexico" ? t('pgmdocuments.document1') : t('businessdocuments.document2')}
                    </label>
                    <input
                      className="business-contact-pages-input cursor-pointer"
                      id="Constitutive_act"
                      onChange={handleFileConstitutiveact}
                      hidden
                      type="file"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.ex-businesstaxid') : t('common.+upload')}
                      name="userid"
                      accept="image/png,image/jpg, image/jpeg,.pdf"
                      ref={fileConstitutive_act}
                    />
                    <input
                      type="text"
                      id="Constitutive_act"
                      readOnly
                      className="selectfile-file cursor-pointer"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.ex-businesstaxid') : t('common.+upload')}
                      value={constitutiveact?.name}
                      onClick={() => fileConstitutive_act.current.click()}
                    />
                    {Country_name.toLowerCase() === "mexico" ?
                      <span class="business-partners-span-text cursor-pointer" onClick={() => fileConstitutive_act.current.click()}>
                        {Country_name.toLowerCase() === "mexico" ? t('common.+upload') : t('businessdocuments.document1')}
                      </span>
                      : ""}
                    <label
                      className="select-vehicle-input cursor-pointer"
                      htmlFor="other"
                    ></label>
                  </div>
                  <div class="input-wrapper inputsbusinessrecords cursor-pointer">
                    <label for="search" htmlFor="other">
                      {Country_name.toLowerCase() === "mexico" ? t('pgmdocuments.document2') : t('businessdocuments.document3')}
                    </label>
                    <input
                      className="business-contact-pages-input cursor-pointer"
                      id="Rfc"
                      onChange={handleFilerec}
                      hidden
                      type="file"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.ex-addressproof,others') : t('common.+upload')}
                      name="userid"
                      accept="image/png,image/jpg, image/jpeg,.pdf"
                      ref={filerec}
                    />
                    <input
                      type="text"
                      id="Rfc"
                      readOnly
                      className="selectfile-file cursor-pointer"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.ex-addressproof,others') : t('common.+upload')}
                      value={rec?.name}
                      onClick={() => filerec.current.click()}
                    />
                    {Country_name.toLowerCase() === "mexico" ?
                      <span class="business-partners-span-text cursor-pointer" onClick={() => filerec.current.click()}>
                        {Country_name.toLowerCase() === "mexico" ? t('common.+upload') : t('businessdocuments.document1')}
                      </span>
                      : ""}
                    <label
                      className="select-vehicle-input"
                      htmlFor="Rfc"
                    ></label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div>
                <div className="busiess-partners-veryfications-documents">
                  <div class="input-wrapper inputsbusinessrecords cursor-pointer">
                    <label for="search" htmlFor="other">
                      {Country_name.toLowerCase() === "mexico" ? t('pgmdocuments.document3') : t('businessdocuments.document4')}
                    </label>
                    <input
                      className="business-contact-pages-input cursor-pointer"
                      id="address"
                      onChange={handleFileaddressProof}
                      hidden
                      type="file"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.ex-bankdetailsetc') : t('common.+upload')}
                      name="userid"
                      accept="image/png,image/jpg, image/jpeg,.pdf"
                      ref={fileaddressProof}
                    />
                    <input
                      type="text"
                      id="address"
                      readOnly
                      className="selectfile-file cursor-pointer"
                      placeholder={Country_name.toLowerCase() === "mexico" ? t('common.ex-bankdetailsetc') : t('common.+upload')}
                      value={addressProof?.name}
                      onClick={() => fileaddressProof.current.click()}
                    />
                    {Country_name.toLowerCase() === "mexico" ?
                      <span class="business-partners-span-text cursor-pointer" onClick={() => fileaddressProof.current.click()}>
                        {Country_name.toLowerCase() === "mexico" ? t('common.+upload') : t('businessdocuments.document1')}
                      </span>
                      : ""}
                    <label
                      className="select-vehicle-input cursor-pointer"
                      htmlFor="address"
                    ></label>
                  </div>
                  {Country_name.toLowerCase() === "mexico" ? "" :
                    <>
                      <div class="input-wrapper inputsbusinessrecords cursor-pointer">
                        <label for="search" htmlFor="other">
                          {Country_name.toLowerCase() === "mexico" ? t('pgmdocuments.document3') : t('businessdocuments.document5')}
                        </label>
                        <input
                          className="business-contact-pages-input cursor-pointer"
                          id="Bank_receipt"
                          onChange={handleFilebankAccount}
                          hidden
                          type="file"
                          placeholder={t('common.+upload')}
                          name="userid"
                          accept="image/png,image/jpg, image/jpeg,.pdf"
                          ref={filebankAccount}
                        />
                        <input
                          type="text"
                          id="Bank_receipt"
                          readOnly
                          className="selectfile-file cursor-pointer"
                          placeholder={t('common.+upload')}
                          value={bankAccount?.name}
                          onClick={() => filebankAccount.current.click()}
                        />
                        <label
                          className="select-vehicle-input cursor-pointer"
                          htmlFor="Bank_receipt"
                        ></label>
                      </div>
                      <div class="input-wrapper inputsbusinessrecords">
                        <label for="search" htmlFor="other">
                          {Country_name.toLowerCase() === "mexico" ? t('businessdetail.other') : t('businessdocuments.document6')}
                        </label>
                        <input
                          className="business-contact-pages-input cursor-pointer"
                          id="other_file"
                          onChange={handleFileotherfile}
                          hidden
                          type="file"
                          placeholder={t('common.+upload')}
                          name="userid"
                          accept="image/png,image/jpg, image/jpeg,.pdf"
                          ref={fileotherfile}
                        />
                        <input
                          type="text"
                          id="other_file"
                          readOnly
                          className="selectfile-file cursor-pointer"
                          placeholder={t('common.+upload')}
                          value={otherfile?.name}
                          onClick={() => fileotherfile.current.click()}
                        />
                        <label
                          className="select-vehicle-input"
                          htmlFor="other_file"
                        ></label>
                      </div>
                    </>
                  }
                </div>
              </div>
            </div>

            <div className="photosStore">{t('businessdetail.photostrore')}</div>
            <div className="facadetext">
              {t('businessdetail.photostoresuggestion')}
            </div>
            <input
              type="file"
              multiple
              onChange={handleImageChange}
              id="store_img"
              hidden
              name="userid"
              accept="image/png,image/jpg, image/jpeg"
              ref={store_image}
            />
            <div>
              <div className="pgm_details_eight_paras">
                <div className="veryfication_img">
                  {selectedImages.map((image, index) => (
                    <span className="stores-image" key={index}>
                      <img
                        height="125px"
                        width="125px"
                        key={index}
                        src={DOMPurify.sanitize(URL.createObjectURL(image.file))}
                        alt={`Preview ${index}`}
                      />
                      <img
                        alt={`Delete ${index}`}
                        key={index}
                        className="store-image-del"
                        src={Image_Url.DELETE_STORE_IMAGE}
                        onClick={(e) => deleteStorephoto(image.id)}
                      />
                    </span>
                  ))}
                </div>
                {selectedImages.length === 4 ? (
                  ""
                ) : (
                  <div className="veryfication_img-plus">
                    <span></span>
                    <p className="plusicons">
                      {imgLoading ? (
                        <Loader className="login-loader" />
                      ) : (
                        <img
                          alt="img"
                          src={Image_Url.IMAGE_ADD}
                          onClick={() => store_image.current.click()}
                        />
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className={Country_name.toLowerCase() === "mexico" ? "business_paraseven" : "disable_business_paraseven"}>
              <input
                type="checkbox"
                className="input_checkbox"
                checked={isChecked}
                disabled={isChecked}
              />
              <span
                className="AcceptPrivacyLink"
              > {t('businessdetail.accept')}
                <p onClick={Country_name.toLowerCase() === "mexico" ? RedirectPrivacyPolicy : undefined}
                  className="PrivacyPolicyText">{t('businessdetail.privacyPolicy')}</p>
              </span>
              <span style={{ color: "red" }}>*</span>
            </div>
            <div className="eleven_para_partners">
              <button
                className="next_buttons"
                onClick={addBusinesspartner}
                disabled={
                  (sameadress ? states?.detailed_address === "" : states?.delivery_address?.[0]?.detailed_address === "") ||
                  !isChecked ||
                  states.role === "" ||
                  (states.name_of_business.length < 3) ||
                  (states.name_of_business.length > 25) ||
                  (states.name_as_per_business_record.length < 3) ||
                  (states.name_as_per_business_record.length > 25) ||
                  states.gps_address === "" ||
                  (!CityStateValidation && states?.city === "") ||
                  states.postal_code === "" ||
                  states.received_training_by_tvs === "" ||
                  (!CityStateValidation && states?.province === "") ||
                  (!sameadress &&
                    !CityStateValidation &&
                    states?.delivery_address?.[0]?.city !== undefined &&
                    states?.delivery_address?.[0]?.city === "") ||
                  (!sameadress &&
                    !CityStateValidation &&
                    states?.delivery_address?.[0]?.province !== undefined &&
                    states?.delivery_address?.[0]?.province === "")
                  // states.verification_id === "" ||    // Todo later as per reqirement
                }
              >
                {isLoading ? <Loader /> : <>{t('common.submitButton')}</>}
              </button>
            </div>
          </div>
        </div>
        <div className="footer-div">
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default BusinessPartners;